import React, { useState } from "react";

function SearchKeyword(props) {
  //props
  const { placeholder, onSearch, searchWord } = props;

  //search variable
  const [search_keyword, set_search_keyword] = useState(searchWord);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col s10">
          <div className="div_input_text_search">
            <input
              type="text"
              className="form_input_text"
              placeholder={placeholder}
              value={search_keyword}
              onChange={(e) => set_search_keyword(e.target.value)}
            />
          </div>
        </div>
        <div className="col s2">
          <i
            className="fa fa-search fa-2x btn btn-floating blue"
            onClick={() => onSearch(search_keyword)}
            style={{ zIndex: "0" }}
          ></i>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchKeyword;
